module.exports = __webpack_public_path__ + "static/icons/icon-cancel-6ef5ce40572bd53923e463238f0e4fad.svg";